import store from '../store'
import { ErrorType, pushException } from '../reducers/errorReducer'
import { stripHtml } from 'string-strip-html'
import { isAppContext } from './appHelper'
import { AppContext } from '../config/appConfig'
import MessageForm = Office.MessageForm
import AppointmentForm = Office.AppointmentForm

export function outlookDisplayNewMessageForm(parameters: MessageForm, callback?: (asyncResult?: Office.AsyncResult<void>) => void): void {
    try {
        if ((!isOfficeInitialized() || isAppContext([AppContext.Compose])) && !(parameters.attachments?.length > 0)) {
            parameters.htmlBody =
                parameters.htmlBody &&
                stripHtml(parameters.htmlBody, {
                    dumpLinkHrefsNearby: {
                        enabled: true,
                        putOnNewLine: false,
                        wrapHeads: '[',
                        wrapTails: ']',
                    },
                }).result

            window.location.href = [
                `mailto:${parameters.toRecipients.map(att => att.emailAddress).join(';')}`,
                parameters.bccRecipients ? `&bcc=${parameters.bccRecipients.map(att => att.emailAddress).join(';')}` : undefined,
                `?subject=${encodeURIComponent(parameters.subject) || ''}`,
                parameters.htmlBody ? `&body=${encodeURIComponent(parameters.htmlBody)}` : undefined,
            ]
                .filter(value => value !== undefined)
                .join('')

            callback?.(undefined)
        } else {
            assertOfficeInitialized()

            parameters.subject = parameters.subject?.substring(0, Math.min(parameters.subject.length, 255))
            parameters.htmlBody = parameters.htmlBody?.replaceAll('\n', '<br/>')
            parameters.htmlBody = parameters.htmlBody?.substring(0, Math.min(parameters.htmlBody?.length, 16380))

            if (Office.context.requirements.isSetSupported('Mailbox', '1.9') && Office.context.mailbox.displayNewMessageFormAsync) {
                Office.context.mailbox.displayNewMessageFormAsync(parameters, result => {
                    console.log('displayNewMessageFormAsync: ', result.error)
                    callback?.(result)
                })
            } else {
                Office.context.mailbox.displayNewMessageForm(parameters)
                callback?.(undefined)
            }
        }
    } catch (e) {
        console.log('displayNewMessageForm: ', e)
        store.dispatch(pushException({ id: e.message, type: ErrorType.Outlook, message: e.message }, e))
    }
}

export function outlookDisplayNewAppointmentForm(parameters: AppointmentForm, callback?: (asyncResult?: Office.AsyncResult<void>) => void): void {
    try {
        if (!isOfficeInitialized() || isAppContext([AppContext.Compose])) {
            window.location.href = [
                `webcal:${parameters.requiredAttendees.map(att => att.emailAddress).join(';')}`,
                `?subject=${encodeURIComponent(parameters.subject) || ''}`,
            ]
                .filter(value => value !== undefined)
                .join('')

            callback?.(undefined)
        } else {
            assertOfficeInitialized()

            parameters.subject = parameters.subject?.substring(0, Math.min(parameters.subject.length, 255))
            parameters.body = parameters.body?.replaceAll('\n', '<br/>')
            parameters.body = parameters.body?.substring(0, Math.min(parameters.body?.length, 16380))

            if (Office.context.requirements.isSetSupported('Mailbox', '1.9') && Office.context.mailbox.displayNewAppointmentFormAsync) {
                Office.context.mailbox.displayNewAppointmentFormAsync(parameters as Office.AppointmentForm, result => {
                    console.log('displayNewAppointmentFormAsync: ', result.error)
                    callback?.(result)
                })
            } else {
                Office.context.mailbox.displayNewAppointmentForm(parameters as Office.AppointmentForm)
                callback?.(undefined)
            }
        }
    } catch (e) {
        console.log('displayNewAppointmentForm: ', e)
        store.dispatch(pushException({ id: e.message, type: ErrorType.Outlook, message: e.message }, e))
    }
}

export function outlookDisplayMessageForm(messageId: string, callback?: (asyncResult?: Office.AsyncResult<void>) => void): void {
    try {
        if (isOfficeInitialized() && messageId) {
            if (Office.context.requirements.isSetSupported('Mailbox', '1.9') && Office.context.mailbox.displayMessageFormAsync) {
                Office.context.mailbox.displayMessageFormAsync(messageId, result => {
                    console.log('outlookDisplayMessageForm: ', result.error)
                    callback?.(result)
                })
            } else {
                Office.context.mailbox.displayMessageForm(messageId)
                callback?.(undefined)
            }
        }
    } catch (e) {
        console.log('displayMessageForm: ', e)
        store.dispatch(pushException({ id: e.message, type: ErrorType.Outlook, message: e.message }, e))
    }
}

export function isOfficeInitialized(): boolean {
    return Office.hasOwnProperty('context') && Office.context.hasOwnProperty('ui')
}

export function isOfficeApplication(): boolean {
    return isOfficeInitialized() && [Office.PlatformType.PC, Office.PlatformType.Mac].includes(Office.context.platform)
}

export function assertOfficeInitialized(): void {
    if (!isOfficeInitialized()) {
        throw new Error('Deze handeling kan alleen vanuit Outlook worden uitgevoerd.')
    }
}
